import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import snackbar from './snackbar'
import i18n from './i18n'

//change dev to prod
import GlobalConfig from '@/config/global.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ethAddress: '',
    ethChainID: '',
    web3: null,
    ethersprovider: null,
    walletConnectProvider: null,
    walletName: '',
    ethpublickey: '',
    networkError: false,
    GlobalConfig: GlobalConfig,
    overlay: false,
    snackbar: {
      isOpen: false,
      title: ''
    },
    contract: {
      /**
       * @SCT合约地址 --测试
       */
      contractAddress: '0xa4B068aD60766E20283C0424C1F543E45100cFE3',
      /**
       * @质押合约地址  --测试
       */
      // pledgeContractAddress: '0xEC52e76571950da8dD20ecf1b065C6699164BD58',
      pledgeContractAddress: '0xaf3b0dA8a3268c62eBB0742B8aDF38dfd0430f8c',
      /**
       * @Agent合约地址 --测试
       */
      agentContractAddress: '0x27875c3C498961ccC4a978b2aE770338938473f3',
      /**
       * @子基金会地址 --测试
       */
      foundationAddress: '0x1CF98d162347fa159b1fAB9d7De7be832aAdFC44'
    }

  },
  mutations: {
    changeContractAddress(state, payload) {
      state.contract = payload
    },
    changeSnackbar(state, payload) {
      state.snackbar = payload
    },
    changeOverlay(state, payload) {
      state.overlay = payload
    },
    changeEthAddress(state, address) {
      state.ethAddress = address
    },
    changeEthChainID(state, id) {
      console.info("changeEthChainID to", id)
      state.ethChainID = id
      state.contract = id == "97"
        ? {
          contractAddress: "0xa4B068aD60766E20283C0424C1F543E45100cFE3",
          pledgeContractAddress: "0xEC52e76571950da8dD20ecf1b065C6699164BD58",
          // pledgeContractAddress: "0xaf3b0dA8a3268c62eBB0742B8aDF38dfd0430f8c",
          agentContractAddress: '0x27875c3C498961ccC4a978b2aE770338938473f3',
          foundationAddress: '0x1CF98d162347fa159b1fAB9d7De7be832aAdFC44'
        }
        : {
          contractAddress: "0x405e7454e71aefe8897438adc08e3f3e6d49dfc1",
          pledgeContractAddress: "0xaf3b0dA8a3268c62eBB0742B8aDF38dfd0430f8c",
          // pledgeContractAddress: "0xd7ae0a202608fA8F37d25706C06b1eE8E4d44D75",
          agentContractAddress: '0xb1307e6294Ed41b614185f00A095FabD98915e6e',
          foundationAddress: '0x88c752D732477e99B6B9cc8689D13beBEBa36187'
        }

      console.info("state contract")
      console.table(JSON.parse(JSON.stringify(state.contract)), ["values"])
    },
    changeweb3(state, obj) {
      state.web3 = obj.web3
      state.ethersprovider = obj.ethersprovider
    },
    changeWalletConnectProvider(state, ConnectProvider) {
      state.walletConnectProvider = ConnectProvider
    },
    walletName(state, name) {
      state.walletName = name
    },
    networkError(state, boolean) {
      state.networkError = boolean
    },
    ethpublickey(state, key) {
      state.ethpublickey = key
    }
  },
  actions: {
    async getEthChainID({ state, commit }) {
      try {
        const res = await state.web3.eth.getChainId()
        commit('changeEthChainID', res)
      } catch (error) {
        console.log(error)
      }
    }
  },
  modules: {
    appConfig: appConfigStoreModule,
    app,
    i18n,
    snackbar,
  },
})
